import axios from '../axiosFlotex'

export default {
  getVoivodeship() {
    return axios.get('voivodeship')
  },

  getDictionaries() {
    return axios.get('dictionaries')
  }
}
